import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFilter, changeSort } from "../../features/filter/filterSlice";

const Aside = () => {
  const filter = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            value={filter.sortStatus}
            onChange={(e) => dispatch(changeSort(e.target.value))}
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            {/* handle filter on button click  */}
            <div>
              <input
                type="radio"
                name="filter"
                value="all"
                id="lws-all"
                checked={filter.filterStatus === "all"}
                onChange={(e) => dispatch(changeFilter(e.target.value))}
                className="radio"
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                value="saved"
                id="lws-saved"
                checked={filter.filterStatus === "saved"}
                onChange={(e) => dispatch(changeFilter(e.target.value))}
                className="radio"
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Aside;
